module.exports = __webpack_public_path__ + "img/upload-white.b1a60c4b.svg";